import React, {useEffect} from 'react';
import Tooltip from '@mui/material/Tooltip';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import {withStyles} from '@mui/styles';
import {Check, Clear, Email, LinkedIn, Phone, PhoneAndroid} from '@mui/icons-material';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import {Grid, TextField} from '@mui/material';
import {useParams} from 'react-router-dom';
import {connect} from 'react-redux';
import {actions as opportunityActions, selectors as opportunitySelectors,} from "../../../../Ducks/opportunity";
import {bindActionCreators} from 'redux';
import logo from "../../../../Assets/icons/f5-logo.svg";
import {ERP_BASE_URL} from '../../../../API/util';
import {RESALE} from "../../../Utils/constants";
import EditIcon from "@mui/icons-material/Edit";
import Swal from "sweetalert2";
import LanguageIcon from "@mui/icons-material/Language";
import {VerifiedEmailIcon} from "../../../Common/Overview/VerifiedEmailIcon";

const useStyles = _theme => ({
    card: {
        display: 'flex',
        backgroundColor: '#fff'
    },
    cardMedia: {
        borderRadius: '50%',
        maxWidth: '80px',
        margin: '15px auto 0'
    },
    cardContent: {
        flex: 4
    },
    cardActions: {
        display: 'flex',
        alignItems: 'flex-end',
        marginRight: '-8px',
        marginBottom: '-18px',
        justifyContent: 'end'
    }
});

function Persons(props) {
    const {classes, person, updateContact, updatePrimaryJobEmail, updatePrimaryJobEmailError} = props;
    const [personObj, setPersonObj] = React.useState([]);
    const [editMobile, setEditMobile] = React.useState(false);
    const [editEmail, setEditEmail] = React.useState(false);
    const [editPhone, setEditPhone] = React.useState(false);
    const [mobile, setMobile] = React.useState('');
    const [email, setEmail] = React.useState('');
    const [phone, setPhone] = React.useState('');
    const [personId, setPersonId] = React.useState('');

    useEffect(() => {
        if (person && person.length !== 0) {
            let personID = person.related_objects.jobs[person.main.job_id].person_id;
            let obj = person.related_objects.persons[personID];
            let miniProfile = person.related_objects.mini_profile ? person.related_objects.mini_profile[obj.mini_profile] : {};
            setPersonObj({...obj, ...miniProfile});
            setPersonId(personID);
            setMobile(obj.mobile === null ? "" : obj.mobile)
            setEmail(obj.email === null ? "" : obj.email) // email of a person
            setPhone(obj.phone === null ? "" : obj.phone); // Job number or direct number
        }
    }, [person]);

    useEffect(() => {
        if (updatePrimaryJobEmailError?.message && personObj) {
            setEmail(personObj.email);
        }
    }, [updatePrimaryJobEmailError]);

    return (
        <Card className={classes.card}>
            <Grid container spacing={2} style={{marginBottom: "10px"}}>
                <Grid item xs={4}>
                    <CardMedia
                        className={classes.cardMedia}
                        component="img"
                        alt="person image"
                        image={`${ERP_BASE_URL}/uploads/images/persons/${personObj.person_token}.jpg`}
                    />
                </Grid>
                <Grid item xs={8}>
                    <CardContent className={classes.cardContent}>
                        <div style={{marginBottom: '10px'}}>
                            <Typography style={{fontSize: '18px'}} variant="h6" component="div">
                                {personObj.person_firstname} {personObj.person_lastname}
                            </Typography>
                            <Typography style={{marginBottom: "10px"}} variant="body2" color="site.main">
                                {personObj.title}
                            </Typography>
                            <div style={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start'}}>

                                <Typography variant="body2" color="site.main">
                                    <a target="_blank" rel="noreferrer" href={personObj.person_linkedin_url}><LinkedIn
                                        sx={{color: 'icon.linkedin', fontSize: "44px"}}/></a>
                                </Typography>
                                <Typography variant="body2" color="site.main">
                                    <a target="_blank" rel="noreferrer"
                                       href={ERP_BASE_URL + "/#/contacts/persons/" + personObj.person_id}>
                                        <img alt="" src={logo} className="logo-link"></img>
                                    </a>
                                </Typography>
                            </div>
                        </div>
                        <div style={{marginBottom: '5px', paddingBottom: '4px'}}>
                            <Typography variant="body2" color="site.main" component="div">
                                <Typography style={{display: 'flex', alignItems: 'center'}} component="p">
                                    <LanguageIcon sx={{color: 'icon.main', fontSize: "20px"}}/>
                                    <span style={{marginLeft: '8px', fontSize: '0.875rem'}}>
                                        {personObj.mp_location_region}
                                    </span>
                                </Typography>
                            </Typography>
                        </div>

                        <div style={{marginBottom: '5px'}}>
                            {
                                !editMobile && (
                                    <div style={{display: 'flex', justifyContent: 'space-between'}}>
                                        <Typography variant="body2" color="site.main" component="div">
                                            <a href={`callto:${personObj.mobile}`} onClick={props.showActiveTab}
                                               style={{
                                                   textDecoration: 'none',
                                                   color: 'inherit',
                                                   display: 'flex',
                                                   alignItems: 'center'
                                               }}>
                                                <PhoneAndroid sx={{color: 'icon.main', fontSize: "20px"}}/>
                                                {
                                                    personObj.mobile !== null && personObj.mobile !== "" ?
                                                        <Tooltip title="Mobile Number" placement="top">
                                                            <span style={{marginLeft: '8px'}}>
                                                                {mobile}
                                                            </span>
                                                        </Tooltip>
                                                        :
                                                        <span style={{marginLeft: '8px'}}>
                                                            Add mobile number
                                                        </span>
                                                }
                                            </a>
                                        </Typography>
                                        {
                                            person.main.self_opportunity && (
                                                <Typography variant="body2" color="site.main" component="div">
                                                    <Tooltip title="Edit Mobile Number" placement="top">
                                                        <EditIcon sx={{color: "icon.main", fontSize: '20px', cursor: 'pointer'}}
                                                                  onClick={() => {
                                                                      setEditMobile(true)
                                                                  }}/>
                                                    </Tooltip>
                                                </Typography>
                                            )
                                        }
                                    </div>
                                )
                            }
                            {
                                editMobile && person.main.self_opportunity && (
                                    <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                                        <TextField
                                            type="number"
                                            id="mobile"
                                            label="Mobile"
                                            variant="outlined"
                                            size="small"
                                            style={{marginTop: "10px"}}
                                            value={mobile}
                                            onChange={(e) => {
                                                setMobile(e.target.value);
                                            }}
                                        ></TextField>
                                        <Typography variant="body2" color="site.main" component="div"
                                                    sx={{display: 'flex', marginLeft: '5px'}}>
                                            <Check sx={{color: 'green', fontSize: "20px", cursor: 'pointer'}}
                                                   onClick={() => {
                                                       let contactData = {
                                                           id: personId,
                                                           obj: {person_mobile_number: mobile},
                                                           key: 'person_mobile_number',
                                                           opportunityId: props.params.id
                                                       }
                                                       updateContact(contactData);
                                                       setEditMobile(false);
                                                   }}/>
                                            <Clear sx={{color: 'red', fontSize: "20px", cursor: 'pointer'}} onClick={() => {
                                                setEditMobile(false);
                                                setMobile(personObj.mobile);
                                            }}/>
                                        </Typography>
                                    </div>
                                )
                            }
                        </div>

                        {/* This is a job number or direct number */}
                        <div style={{marginBottom: '5px'}}>
                            {
                                !editPhone && (
                                    <div style={{display: 'flex', justifyContent: 'space-between'}}>
                                        <Typography variant="body2" color="site.main" component="div">
                                            <a href={`callto:${personObj.phone}`} onClick={props.showActiveTab} style={{
                                                textDecoration: 'none',
                                                color: 'inherit',
                                                display: 'flex',
                                                alignItems: 'center'
                                            }}>
                                                <Phone sx={{color: 'icon.main', fontSize: "20px"}}/>
                                                {
                                                    personObj.phone !== null && personObj.phone !== "" ?
                                                        <Tooltip title="Direct Number">
                                                            <span style={{marginLeft: '8px'}}>
                                                                {phone}
                                                            </span>
                                                        </Tooltip> :
                                                        <span style={{marginLeft: '8px'}}>
                                                            Add direct number
                                                        </span>
                                                }

                                            </a>
                                        </Typography>
                                        {
                                            person.main.self_opportunity && (
                                                <Typography variant="body2" color="site.main" component="div">
                                                    <Tooltip title="Edit Direct Number">
                                                        <EditIcon sx={{color: "icon.main", fontSize: '20px', cursor: 'pointer'}}
                                                                  onClick={() => {
                                                                      setEditPhone(true)
                                                                  }}/>
                                                    </Tooltip>
                                                </Typography>
                                            )
                                        }
                                    </div>
                                )
                            }
                            {
                                editPhone && person.main.self_opportunity && (
                                    <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                                        <TextField
                                            type="number"
                                            id="phone"
                                            label="Direct Number"
                                            variant="outlined"
                                            size="small"
                                            style={{marginTop: "10px"}}
                                            value={phone}
                                            onChange={(e) => {
                                                setPhone(e.target.value);
                                            }}
                                        ></TextField>
                                        <Typography variant="body2" color="site.main" component="div"
                                                    sx={{display: 'flex', marginLeft: '5px'}}>
                                            <Check sx={{color: 'green', fontSize: "20px", cursor: 'pointer'}}
                                                   onClick={() => {
                                                       let contactData = {
                                                           jobID: person.main.job_id,
                                                           obj: {job_phone: phone},
                                                           opportunityId: props.params.id
                                                       }
                                                       props.updateJobPhone(contactData);
                                                       setEditPhone(false);
                                                   }}/>
                                            <Clear sx={{color: 'red', fontSize: "20px", cursor: 'pointer'}} onClick={() => {
                                                setEditPhone(false);
                                                setPhone(personObj.phone);
                                            }}/>
                                        </Typography>
                                    </div>
                                )
                            }
                        </div>

                        {/* This is a primary job email */}
                        <div style={{marginBottom: '5px'}}>
                            {
                                !editEmail && (
                                    <div style={{display: 'flex', justifyContent: 'space-between'}}>
                                        <Typography variant="body2" color="site.main" component="div">
                                            <a href={`mailto:${personObj.email}`} style={{
                                                textDecoration: 'none',
                                                color: 'inherit',
                                                display: 'flex',
                                                alignItems: 'center'
                                            }}>
                                                <Email sx={{color: 'icon.main', fontSize: "20px"}}/>
                                                {
                                                    personObj.email !== null && personObj.email !== "" ?
                                                        (
                                                            <>
                                                                <span style={{
                                                                    marginLeft: '8px',
                                                                    wordBreak: 'break-all',
                                                                    lineHeight: 1
                                                                }}>
                                                                    {personObj.email}
                                                                </span>
                                                            </>
                                                        ) :
                                                        <span style={{marginLeft: '8px'}}>
                                                            Add primary job email
                                                        </span>
                                                }
                                            </a>
                                        </Typography>

                                        <Typography variant="body2" color="site.main" sx={{display: 'flex'}}>
                                            <VerifiedEmailIcon person={{...personObj, primary_job_email: email}}
                                                               positionTop="1px"/>

                                            {person?.main?.self_opportunity && (
                                                <Tooltip title="Edit Email Address" placement="top">
                                                    <EditIcon sx={{color: "icon.main", fontSize: '20px', cursor: 'pointer'}}
                                                              onClick={() => {
                                                                  setEditEmail(true)
                                                              }}/>
                                                </Tooltip>
                                            )}
                                        </Typography>
                                    </div>
                                )
                            }
                            {
                                editEmail && person.main.self_opportunity && (
                                    <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                                        <TextField
                                            type="email"
                                            id="email"
                                            label="Primary Job Email"
                                            variant="outlined"
                                            size="small"
                                            style={{marginTop: "10px"}}
                                            value={email}
                                            onChange={(e) => {
                                                setEmail(e.target.value);
                                            }}
                                        ></TextField>
                                        <Typography variant="body2" color="site.main"
                                                    sx={{display: 'flex', marginLeft: '5px'}}>
                                            <Check sx={{color: 'green', fontSize: "20px", cursor: 'pointer'}}
                                                   onClick={() => {
                                                       let contactData = {
                                                           jobID: person.main.job_id,
                                                           personId: personId,
                                                           obj: {job_email: email},
                                                           key: 'job_email',
                                                           opportunityId: props.params.id
                                                       }

                                                       if (person.main.opportunity_type === RESALE) {
                                                           Swal.fire({
                                                               title: 'Are you sure?',
                                                               text: `By confirming, ${personObj.person_firstname} ${personObj.person_lastname} 
                                                            will receive the invitation
                                                            for all upcoming events at the ${email}.`,
                                                               icon: 'warning',
                                                               showCancelButton: true,
                                                               confirmButtonColor: '#3085d6',
                                                               cancelButtonColor: '#d33',
                                                               confirmButtonText: 'Confirm',
                                                               cancelButtonText: 'Cancel'
                                                           })
                                                               .then(result => {
                                                                   if (result.isConfirmed) {
                                                                       updatePrimaryJobEmail(contactData)
                                                                   } else {
                                                                       setEmail(personObj.email);
                                                                   }
                                                               });
                                                       } else {
                                                           updatePrimaryJobEmail(contactData);
                                                       }

                                                       setEditEmail(false);
                                                   }}/>
                                            <Clear sx={{color: 'red', fontSize: "20px", cursor: 'pointer'}} onClick={() => {
                                                setEditEmail(false);
                                                setEmail(personObj.email);
                                            }}/>
                                        </Typography>
                                    </div>
                                )
                            }
                        </div>
                    </CardContent>
                    <CardActions className={classes.cardActions}>
                        <Button variant="contained" color="secondary" endIcon={<ArrowRightAltIcon/>} size="small"
                                onClick={() => props.handleTabChange('person')}>Person</Button>
                    </CardActions>
                </Grid>

            </Grid>
        </Card>
    );
}

const mapStateToProps = (state) => ({
    isLoading: opportunitySelectors.updateContact_loading(state),
    updatePrimaryJobEmailError: opportunitySelectors.updatePrimaryJobEmail_error(state),
    opportunity: opportunitySelectors.opportunity(state)
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            updateContact: opportunityActions.updateContact,
            updatePrimaryJobEmail: opportunityActions.updatePrimaryJobEmail,
            updateDivisionPhone: opportunityActions.updateDivisionPhone,
            updateJobPhone: opportunityActions.updateJobPhone,
        },
        dispatch
    );

function WithNavigate(props) {
    let params = useParams();
    return <Persons {...props} params={params}/>
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(useStyles)(WithNavigate));